import React, { useState, useCallback, createRef, useEffect } from "react";
import Container from "../../Container/Container";
import Steppers from "../../components/Stepper/Stepper";
import "./Uploaddesign.scss";
import upload from "../../assets/upload.png";
import Buttons from "../../components/Button/Button";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { productData } from "../../store/action";
import { useDropzone } from "react-dropzone";
import Modals from "../../components/Modal/Modal";
import { Rnd } from "react-rnd";
import { useScreenshot } from "use-react-screenshot";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowIcon from "../../assets/diagonal-arrow.png";
import { API, graphqlOperation } from "aws-amplify";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "../../components/Snackbar/Snackbar";
import {
  createProductTable,
  updateProductTable,
} from "../../graphql/mutations";
import { Storage } from "aws-amplify";
import switchImg from "../../assets/switch.jpg";
import { draftId } from "../../store/action/index";
const Uploaddesign = () => {
  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "999",
  };

  const ref = createRef(null);
  const ref1 = createRef(null);
  const [image, takeScreenshot] = useScreenshot();
  const [image1, takeScreenshot1] = useScreenshot();
  const [imageblob, setimageblob] = useState({});
  const [image1blob, setimage1blob] = useState({});
  const login = useSelector((state) => state.login);
  const product = useSelector((state) => state.product);
  const draftProductId = useSelector((state) => state.draftId.draftProductId);
  const dataurl2 = [];
  const dataurl = [];
  const dispatch = useDispatch();
  const status = login.loginStatus;
  const history = useHistory();
  const [modal, setmodal] = useState(false);
  const [openmodal, setopenmodal] = useState(false);
  const [icon, setIcon] = useState(false);
  const [isBorder, setIsBorder] = useState(true);
  const [shirtposition, setposition] = useState("front");
  const [base64, setbase64] = useState("");
  const [base64cond, setbase64cond] = useState(false);
  const { t } = useTranslation();
  const [price, setPrice] = useState(false);
  const [loader, setLoader] = useState(false);
  const [noImg, setNoImg] = useState(true);
  const [noscan, setnoscan] = useState(false);

  const [imgsizefront, setimagesizefront] = useState({
    width: product?.frontDesignObj ? product.frontDesignObj.width : "auto",
    height: product?.frontDesignObj ? product.frontDesignObj.height : "auto",
    x: product?.frontDesignObj ? product.frontDesignObj.x : -10,
    y: product?.frontDesignObj ? product.frontDesignObj.y : 0,
  });
  const [msg, setmsg] = useState("");
  const [errMsg, seterrMsg] = useState("");
  const [imgsizeback, setimagesizeback] = useState({
    width: product?.backDesignObj?.width
      ? product?.backDesignObj?.width
      : "auto",
    height: product?.backDesignObj?.height
      ? product?.backDesignObj?.height
      : "auto",
    // status: false,

    x: product?.backDesignObj?.x ? product?.backDesignObj?.x : -10,
    y: product?.backDesignObj?.y ? product?.backDesignObj?.y : -10,
  });
  const [frontDesignExist, setFrontDesignExist] = useState(false);
  const [backDesignExist, setBackDesignExist] = useState(false);

  const changeimg = () => {
    if (shirtposition === "front") {
      setposition("back");
    } else {
      setposition("front");
    }
  };

  const checklogin = () => {
    setopenmodal(true);
    if (status) {
      setmodal(false);
    } else {
      setmodal(true);
      setopenmodal(true);
    }
  };

  const priceroute = () => {
    // console.log("when upload imgsizefront==>", imgsizefront);
    if (product?.shirtdesign.length || product?.shirtdesignback.length) {
      setposition("front");
      setnoscan(true);
      dispatch(
        productData({
          frontDesignObj: imgsizefront,
          backDesignObj: imgsizeback,
        })
      );
      setPrice(true);
      if (product.shirtdesign.length > 0) {
        setIsBorder(false);
      } else {
        setNoImg(false);
        setIsBorder(false);
      }
    } else {
      seterrMsg(t("design-upload"));
      setTimeout(() => {
        seterrMsg("");
      }, 2000);
    }
  };

  useEffect(() => {
    if (!isBorder) {
      takeScreenshot(ref.current, { scale: 2, dpi: 480 });
    }
  }, [isBorder]);

  useEffect(() => {
    if (!isBorder && shirtposition === "back") {
      takeScreenshot1(ref1.current, { scale: 2, dpi: 480 });
    }
  }, [imageblob]);

  const imagetoblob = async () => {
    let url = image;
    let res = await fetch(url);
    let blob = await res?.blob();
    setimageblob(blob);
  };

  const image1toblob = async () => {
    let url = image1;
    let res = await fetch(url);
    let blob = await res?.blob();
    setimage1blob(blob);
  };
  useEffect(() => {
    if (image) {
      imagetoblob();
      if (product.shirtdesignback.length > 0) {
        setposition("back");
        setNoImg(true);
      } else {
        setNoImg(false);
        setposition("back");
      }
    }
  }, [image]);

  useEffect(() => {
    if (image1) {
      image1toblob();
    }
  }, [image1]);

  useEffect(() => {
    if (image1blob.size) {
      setTimeout(() => {
        setNoImg(true);
        setposition("front");
        addProductStep1();
      }, 1000);
    }
  }, [image1blob]);
  const chooseroute = () => {
    setLoader(true);
    dispatch(
      productData({
        step: 0,
      })
    );
    history.push("/");
  };
  //image saved in state
  const onDrop = useCallback((acceptedFiles) => {
    setbase64cond(false);
    setbase64cond(true);
    setbase64("");
    var reader = new FileReader();
    reader.readAsDataURL(acceptedFiles[0]);
    reader.onload = function () {
      setbase64(reader.result);
    };
  }, []);

  useEffect(() => {
    if (base64cond === true) {
      if (shirtposition === "front") {
        // setimagesizefront({ ...imgsizefront, status: true });
        setFrontDesignExist(true);
        dispatch(
          productData({
            shirtdesign: [
              {
                preview: base64,
              },
            ],
          })
        );
      } else {
        //   setimagesizeback({ ...imgsizeback, status: true });
        setBackDesignExist(true);
        dispatch(
          productData({
            shirtdesignback: [
              {
                preview: base64,
              },
            ],
          })
        );
      }
    } else {
      setbase64cond(false);
    }
  }, [base64]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const shirtclr = (data) => {
    dispatch(
      productData({
        color: data,
      })
    );
  };

  const deletedesign = () => {
    if (shirtposition === "front") {
      //   setimagesizefront({ ...imgsizefront, status: false });
      setFrontDesignExist(false);
      dispatch(
        productData({
          shirtdesign: [],
        })
      );
    } else {
      //   setimagesizeback({ ...imgsizeback, status: false });
      setBackDesignExist(false);
      dispatch(
        productData({
          shirtdesignback: [],
        })
      );
    }
  };
  useEffect(() => {
    dispatch(
      productData({
        step: 1,
      })
    );
    if (login.loginStatus) {
      setIcon(true);
    }
  }, []);
  useEffect(() => {
    dispatch(
      productData({
        color: product.color,
      })
    );
  }, [product.color]);
  useEffect(() => {
    dispatch(
      productData({
        ...product,
        shirt: { ...product.shirt, cost: product.hello.cost },
      })
    );
  }, []);
  const addProductStep1 = async () => {
    // console.log("front==>", frontDesignExist);
    // console.log("back==>", backDesignExist);

    setnoscan(false);
    setLoader(true);
    const pic = await [
      product?.shirtdesign[0]?.preview,
      product?.shirtdesignback[0]?.preview,
    ];
    for (let index = 0; index < pic?.length; index++) {
      const filename = Date.now();
      const base64Data =
        pic[index] &&
        Buffer.from(
          pic[index].replace(/^data:image\/\w+;base64,/, ""),
          "base64"
        );
      const Store = await Storage.put(
        "designproducts/" + filename,
        base64Data,
        {
          ContentEncoding: "base64",
          ContentType: `image/png`,
          Acl: "public-read",
          contentDisposition: "inline",
        }
      );
      const url = await Storage.get(Store.key);
      dataurl2.push(url.split("?")[0]);
    }
    const pic1 = await [imageblob, image1blob];
    for (let index = 0; index < pic1?.length; index++) {
      const filename = Date.now();
      const Store = await Storage.put(
        "designproducts/" + filename,
        pic1[index],
        {
          contentType: "image/png",
        }
      );
      const url = await Storage.get(Store.key);
      dataurl.push(url.split("?")[0]);
    }
    const shirt = await {
      shirtDesignFront: frontDesignExist ? dataurl2[0] : "",
      shirtDesignBack: backDesignExist ? dataurl2[1] : "",
      shirtColor: product.color,
      shirtCategory: product.shirt.category,
      shirtrealName: product.shirt.garmentName,
      designShirt: dataurl[0],
      designShirtBack: dataurl[1],
      frontDesign: {
        height: imgsizefront.height,
        width: imgsizefront.width,
        status: imgsizefront.status,
        x: parseInt(imgsizefront.x),
        y: parseInt(imgsizefront.y),
      },
      backDesign: {
        height: imgsizeback.height,
        width: imgsizeback.width,
        // imgsizefront
        status: imgsizeback.status,
        x: parseInt(imgsizeback.x),
        y: parseInt(imgsizeback.y),
      },
      customerId: login.userDetail,
      color: product.shirt.color,
      frontImg: product.shirt.frontshirturl,
      backImg: product.shirt.backshirturl,
      realprice:
        frontDesignExist && backDesignExist
          ? product.shirt.cost + 5
          : product.shirt.cost,
      sellingPrice: 0,
      quantity: 0,
      step: 2,
      isDone: false,
    };
    try {
      const { data } = await API.graphql(
        graphqlOperation(
          draftProductId ? updateProductTable : createProductTable,
          {
            input: draftProductId ? { ...shirt, id: draftProductId } : shirt,
          }
        )
      );

      dispatch(
        draftId({
          draftProductId: data?.updateProductTable
            ? data?.updateProductTable?.id
            : data?.createProductTable?.id,
        })
      );
      setLoader(false);
      dispatch(
        productData({
          step: 1,
          designnimg: dataurl[0],
          designnimgback: dataurl[1],
          id: data?.updateProductTable
            ? data?.updateProductTable?.id
            : data?.createProductTable?.id,
        })
      );
      history.push("/setprice");
    } catch (err) {
      setLoader(false);
      seterrMsg(err.errors[0].message);
      setTimeout(() => {
        seterrMsg("");
      }, 1500);
    }
  };

  const [imgsData, setimgsData] = useState(false);
  useEffect(() => {
    if (product.shirt.frontImg && product.shirt.backImg) {
      setimgsData(true);
    }
  }, [product.shirt]);

  useEffect(() => {
    if ((product.shirt.frontImg || product.shirt.backImg) && !status) {
      dispatch(
        productData({
          shirtdesign: [],
          shirtdesignback: [],
        })
      );
    }
  }, []);

  // console.log("===>", product.shirt.cost);
  return (
    <>
      <Container>
        <Steppers
          head={t("upload_design")}
          text={`${t("continue")} >`}
          login={status}
          continue={() => {
            priceroute();
          }}
          back={() => chooseroute()}
          loader={loader}
          design
        />
        {imgsData ? (
          <div className="upload_design">
            <div className="clr-main">
              {status && product.shirt.color ? (
                <div className="clr">
                  <div className="clr-plate">
                    {product.shirt.color.map((data, ind) => {
                      return (
                        data &&
                        ind < 5 && (
                          <>
                            <span
                              style={{ background: data }}
                              onClick={() => shirtclr(data)}
                              key={ind}
                            ></span>
                          </>
                        )
                      );
                    })}
                  </div>
                  <div className="clr-plate ">
                    {product.shirt.color.map((data, ind) => {
                      return (
                        data &&
                        ind > 4 &&
                        ind < 10 && (
                          <>
                            <span
                              style={{ background: data }}
                              onClick={() => shirtclr(data)}
                            ></span>
                          </>
                        )
                      );
                    })}
                  </div>
                  <div className="clr-plate ">
                    {product.shirt.color.map((data, ind) => {
                      return (
                        data &&
                        ind > 9 && (
                          <>
                            <span
                              style={{ background: data }}
                              onClick={() => shirtclr(data)}
                            ></span>
                          </>
                        )
                      );
                    })}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="item-img" onDrop={() => checklogin()}>
              <div id="image" className="border-img">
                <div
                  ref={shirtposition === "front" ? ref : ref1}
                  style={{ width: "500px", height: "500px" }}
                >
                  <img
                    src={
                      shirtposition === "front"
                        ? product.shirt.frontImg
                        : product.shirt.backImg
                    }
                    alt=""
                    style={{ backgroundColor: `${product.color}` }}
                    width="500px"
                    height="500px"
                  />
                  <div
                    className={`${noImg && "drag_img"} ${
                      (shirtposition === "front" &&
                        product.shirtdesign.length > 0 &&
                        "border-design") ||
                      (shirtposition === "back" &&
                        product.shirtdesignback.length > 0 &&
                        "border-design")
                    }`}
                  >
                    {(shirtposition === "front" &&
                      product.shirtdesign.length < 1) ||
                    (shirtposition === "back" &&
                      product.shirtdesignback.length < 1) ? (
                      <>
                        {noImg && (
                          <div
                            {...getRootProps()}
                            onChange={() => checklogin()}
                          >
                            {<input {...getInputProps()} />}
                            <h5>{t("drag_design")}</h5>
                            <p>{t("drop_design")}</p>
                            <img
                              src={upload}
                              alt="t-shirt"
                              className="drag-img"
                              width={50}
                              height={50}
                            />
                            <p>
                              {t("png_format")}
                              <br />
                              {t("maximize_quality")}
                            </p>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {}
                        <div>
                          <Rnd
                            style={style}
                            size={
                              shirtposition === "front"
                                ? {
                                    width: imgsizefront.width,
                                    height: imgsizefront.height,
                                  }
                                : {
                                    width: imgsizeback.width,
                                    height: imgsizeback.height,
                                  }
                            }
                            position={
                              shirtposition === "front"
                                ? { x: imgsizefront.x, y: imgsizefront.y }
                                : { x: imgsizeback.x, y: imgsizeback.y }
                            }
                            onDragStop={(e, d) => {
                              shirtposition === "front"
                                ? setimagesizefront({
                                    ...imgsizefront,
                                    x: d.x,
                                    y: d.y,
                                  })
                                : setimagesizeback({
                                    ...imgsizeback,
                                    x: d.x,
                                    y: d.y,
                                  });
                            }}
                            onResizeStop={(
                              e,
                              direction,
                              ref,
                              delta,
                              position
                            ) => {
                              shirtposition === "front"
                                ? setimagesizefront({
                                    ...position,
                                    width: ref.style.width,
                                    height: ref.style.height,
                                  })
                                : setimagesizeback({
                                    ...position,
                                    width: ref.style.width,
                                    height: ref.style.height,
                                  });
                            }}
                            bounds="#image"
                            lockAspectRatio
                          >
                            <img
                              src={
                                // null
                                shirtposition === "front"
                                  ? product.shirtdesign[0].preview
                                    ? product.shirtdesign[0].preview
                                    : product.shirtdesign
                                  : product?.shirtdesignback[0]?.preview
                                  ? product?.shirtdesignback[0]?.preview
                                  : product?.shirtdesignback
                              }
                              style={{
                                width: "100%",
                                height: "100%",
                                border: `${
                                  isBorder ? "1px solid black" : "0px"
                                }`,
                              }}
                              alt="fabric"
                              draggable="false"
                            />
                            {isBorder && (
                              <>
                                <div className="resize-icon">
                                  <img
                                    src={ArrowIcon}
                                    alt="arrow resize icon"
                                    width={17}
                                    height={17}
                                    className="arrowicon"
                                  />
                                </div>
                                <div>
                                  <DeleteIcon
                                    className="resize-delete"
                                    onClick={() => deletedesign()}
                                  />
                                </div>
                              </>
                            )}
                          </Rnd>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              {(shirtposition === "front" && product.shirtdesign.length < 1) ||
                (icon && (
                  <>
                    {shirtposition === "front" && (
                      <div className="img-border"></div>
                    )}
                  </>
                ))}
              {(shirtposition === "back" &&
                product.shirtdesignback.length < 1) ||
                (icon && (
                  <>
                    {shirtposition === "back" && (
                      <div className="img-border"></div>
                    )}
                  </>
                ))}
              <div className={"postion-btn2"}>
                {noscan ? (
                  <p style={{ marginLeft: "-8px" }}>{t("Wait_scanning")}</p>
                ) : (
                  <div>
                    <Buttons
                      src={switchImg}
                      text={
                        shirtposition === "front"
                          ? `${t("back")}`
                          : `${t("front")}`
                      }
                      onClick={() => changeimg()}
                      className="button signbtn"
                    />
                  </div>
                )}

                <div></div>
              </div>
            </div>
            <div className="card-main">
              {status ? (
                <div className="card">
                  <div>
                    <img
                      src={product.shirt.frontImg}
                      alt="t-shirt"
                      className="item-img"
                      width={100}
                      height={100}
                    />
                  </div>
                  <div>
                    <p className="garment-name">
                      {product.shirt.garmentName.name}
                    </p>
                    <p>
                      <span>{product.shirt.category.name}</span>
                    </p>
                    <Buttons
                      text={`> ${t("change")}`}
                      onClick={() => chooseroute()}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ) : (
          <div
            style={{
              height: "60vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress color="inherit" />
          </div>
        )}
        {modal ? (
          <Modals
            condition="login"
            setopenmodal={setopenmodal}
            setIcon={setIcon}
            openmodal={openmodal}
            setmodal={setmodal}
            escape
          />
        ) : null}
        {msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
      </Container>
    </>
  );
};
export default Uploaddesign;
